import { env } from '@/env';

export function EnvUnsupported() {
  const bot = env.telegramBotUsername;
  const directLink = `https://t.me/${bot}`;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
      <h1 className="text-3xl font-bold text-brand">QLASH</h1>
      <p className="max-w-sm text-sm text-fg-muted">
        This is the QLASH Telegram Mini App. It needs to be launched from
        inside Telegram via the bot — opening the URL directly in a browser
        or in Telegram&apos;s in-app preview won&apos;t work.
      </p>
      <a
        href={directLink}
        className="rounded-md bg-brand px-6 py-3 text-base font-bold text-brand-fg transition-opacity active:opacity-80"
      >
        Open @{bot} in Telegram
      </a>
      <p className="max-w-sm text-xs text-fg-muted">
        Inside the bot chat, tap the <strong>Open App</strong> button (menu
        button at the bottom-left of the chat input).
      </p>
    </div>
  );
}
